/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-form-field[_ngcontent-%COMP%]{display:block;width:100%;margin-top:20px}mat-form-field[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{height:220px}"];
export { styles as styles };
